import {useDebugValue} from 'react';

import {runHPPrePopulateCookieExperiment} from '../../../utils';

import {useValues} from './';

const defaultValues = {
    startDate: '',
    endDate: ''
};

function useDatesValues(props, cookies, system) {
    const {
        datesValues: propsValues
    } = props;

    let {
        datesValues: cookiesValues
    } = cookies;

    cookiesValues = runHPPrePopulateCookieExperiment(cookies, system) ? {} : cookiesValues;

    const {
        initialValues,
        currentValues,
        latestValues,
        setCurrentValues,
        setCurrentValuesDefault,
        setCurrentValuesInitial,
        setCurrentValuesLatest,
        setLatestValues,
        setLatestValuesDefault,
        setLatestValuesInitial,
        setLatestValuesCurrent,
        setAllValues,
        setAllValuesDefault,
        setAllValuesInitial
    } = useValues(defaultValues, cookiesValues, propsValues);

    const result = {
        defaultValues,
        initialValues,
        currentValues,
        latestValues,
        setCurrentValues,
        setCurrentValuesDefault,
        setCurrentValuesInitial,
        setCurrentValuesLatest,
        setLatestValues,
        setLatestValuesDefault,
        setLatestValuesInitial,
        setLatestValuesCurrent,
        setAllValues,
        setAllValuesDefault,
        setAllValuesInitial
    };

    useDebugValue(result);

    return result;
}

export {useDatesValues};
